<template>
  <!-- ModelEasy环境 -->
    <div class="board">
        <div v-hasPermi="['instance:env:details:list']">
            <div class="title">
                <span class="name">{{ meEnvironment.title }}</span>
            </div>
            <el-form :inline="true" :model="form" ref="form">
                <el-form-item>
                    <el-select v-model="form.examPlanId" filterable clearable :placeholder="searchTextConfig.examPlanId">
                        <el-option v-for="(item, index) in examPlanOptions" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.admissionNo" clearable :placeholder="searchTextConfig.admissionNo"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.operatingEnv" clearable :placeholder="searchTextConfig.operatingEnv">
                        <el-option v-for="item in operatingEnvOptions" :key="item.label" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.envStatus" clearable :placeholder="searchTextConfig.envStatus">
                        <el-option v-for="item in envStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search(1)">{{ searchTextConfig.select }}</el-button>
                    <el-button @click="reset">{{ searchTextConfig.reset }}</el-button>
                </el-form-item>
            </el-form>
            <p class="info">
                <el-button v-hasPermi="['instance:env:details:stop']" :disabled="selectRow.length == 0 || selectRow.some(item => item.envStatus == 'stopped')" @click="stop(selectRow, true)" type="warning" size="mini">
                    {{ batchTextConfig.stop.name }}
                </el-button>
                <el-button v-hasPermi="['instance:env:details:delete']" :disabled="selectRow.length == 0" @click="delet(selectRow, true)" type="danger" size="mini">
                    {{ batchTextConfig.remove.name }}
                </el-button>
            </p>
            <el-table :data="tableData" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading" ref="multipleTable" @selection-change="handleSelectionChange" stripe size="medium" :height="height" style="width:100%">
                <el-table-column type="selection" width="48" fixed="left" align="center"></el-table-column>
                <el-table-column prop="exam.examPlan.name" :label="tableTextConfig.examPlanName" min-width="120px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="examinee.examineeName" :label="tableTextConfig.examineeName" min-width="120px"></el-table-column>
                <el-table-column prop="examinee.admissionNo" :label="tableTextConfig.admissionNo" min-width="140px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="operatingEnv" :label="tableTextConfig.operatingEnv" :min-width="flexColumnWidth('operatingEnv', 4, tableData)">
                    <template slot-scope="scope">{{ getOperatingEnvLabel(scope.row.operatingEnv) }}</template>
                </el-table-column>
                <el-table-column prop="startRunTime" :label="tableTextConfig.startRunTime" min-width="160px"></el-table-column>
                <el-table-column prop="runtimeDuration" :label="tableTextConfig.runtimeDuration" min-width="120px">
                    <template slot-scope="scope">{{ formatSeconds(scope.row.runtimeDuration) }}</template>
                </el-table-column>
                <el-table-column :label="tableTextConfig.runtimeDurationTotal" min-width="150px">
                    <template slot-scope="scope">
                        <span>
                            {{formatSeconds(scope.row.runtimeDurationTotal)}} |
                            <span>
                                {{ formatTimes(scope.row.runtimeDurationTimes) }}
                            </span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :label="tableTextConfig.envStatus" min-width="80px">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.envStatus" :type="getStatusType(scope.row.envStatus)">{{ getStatusLabel(scope.row.envStatus) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" :label="tableTextConfig.operate" min-width="160px">
                    <template slot-scope="scope">
                        <el-button v-hasPermi="['instance:env:details:stop']" plain type="warning" size="mini" v-if="scope.row.envStatus === 'running' || scope.row.status === 'RUNNING'" @click="stop([scope.row])">
                            {{ tableButtonTextConfig.stop.name }}
                        </el-button>
                        <el-button v-hasPermi="['instance:env:details:delete']" plain type="danger" size="mini" @click="delet([scope.row])">
                            {{ tableButtonTextConfig.remove.name }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination v-show="tableData.length" :currentPage.sync="form.pageNumber" :pageSize.sync="form.pageSize" :total.sync="total"></pagination>
        </div>
    </div>
</template>

<script>
import pagination from '@/components/pagination/pagination.vue'
import {stopInstanceEnvDetails, deleteInstanceEnvDetails} from "@/api/meEnvironment"


export default {
    components: {
        pagination
    },
    data() {
        return {
            height: 250,
            loading: true,
            form: {
                examPlanId: '',
                admissionNo: '',
                operatingEnv: '',
                envStatus: '',
                pageNumber: 1,
                pageSize: 20
            },
            total: 0,
            trainingMirrorOptions: [],
            examPlanOptions: [],
            envStatusOptions: [
                {
                    value: 'start',
                    label: this.$store.state.global.textConfig.backend.meEnvironment.envStatusEnum.start,
                    type: 'primary'
                },
                {
                    value: 'running',
                    label: this.$store.state.global.textConfig.backend.meEnvironment.envStatusEnum.running,
                    type: 'success'
                },
                {
                    value: 'stopped',
                    label: this.$store.state.global.textConfig.backend.meEnvironment.envStatusEnum.stopped,
                    type: 'warning'
                },
            ],
            operatingEnvOptions: [
                {
                    value: 'project',
                    label: this.$store.state.global.textConfig.backend.meEnvironment.operatingEnvEnum.project
                },
                {
                    value: 'notebook',
                    label: this.$store.state.global.textConfig.backend.meEnvironment.operatingEnvEnum.notebook
                }
            ],
            tableData: [],
            row: null,
            selectRow: [],
            startRow: [],
            stopRow: [],
            deleteRow: [],
        }
    },
    computed: {
        meEnvironment() {
            return this.$store.state.global.textConfig.backend.meEnvironment
        },
        searchTextConfig() {
            return this.meEnvironment.search
        },
        batchTextConfig() {
            return this.meEnvironment.batch
        },
        tableTextConfig() {
            return this.meEnvironment.table
        },
        tableButtonTextConfig() {
            return this.tableTextConfig.button
        },
    },
    watch: {
        tableData() {
            if (this.tableData.length == 0) {
                this.height = 120
            } else {
                this.updateHeight()
            }
        }
    },
    methods: {
        getStatusType(val) {
            for (let i = 0; i < this.envStatusOptions.length; i++) {
                const e = this.envStatusOptions[i];
                if (e.value === val) {
                    return e.type
                }
            }
        },
        getStatusLabel(val) {
            for (let i = 0; i < this.envStatusOptions.length; i++) {
                const e = this.envStatusOptions[i];
                if (e.value === val) {
                    return e.label
                }
            }
        },
        getOperatingEnvLabel(val) {
            for (let i = 0; i < this.operatingEnvOptions.length; i++) {
                const e = this.operatingEnvOptions[i];
                if (e.value === val) {
                    return e.label
                }
            }
        },
        handleSelectionChange(val) {
            this.selectRow = val
        },
        search(val) {
            this.loading = true
            if (val) {
                this.form.pageNumber = val
            }
            let form = JSON.parse(JSON.stringify(this.form))
            this.$store.dispatch("getMeEnvironmentList", form).then(res => {
                if (res.status == 200) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                }
                this.loading = false
                this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
            }).catch(err => {
                console.log(err);
                this.loading = false
            })
        },
        reset() {
            this.form = {
                examPlanId: '',
                admissionNo: '',
                operatingEnv: '',
                envStatus: '',
                pageNumber: 1,
                pageSize: 20
            }
            this.form.pageSize = 20
            this.search(1)
        },
        stop(rows, bool) {
            const ids = rows.map(item => item.id).join(',');
            let title = bool ? this.batchTextConfig.stop.title : this.tableButtonTextConfig.stop.title
            let message = bool ? this.batchTextConfig.stop.message : this.tableButtonTextConfig.stop.message
            let stopTextConfig = this.tableButtonTextConfig.stop
            this.$confirm(message, title, {
                confirmButtonText: stopTextConfig.ok,
                cancelButtonText: stopTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                stopInstanceEnvDetails({ids: ids}).then(res => {
                    this.$message({
                        type: 'success',
                        message: stopTextConfig.success
                    });
                    this.search(1)
                })
            })
        },
        delet(rows, bool) {
            const ids = rows.map(item => item.id).join(',');
            let title = bool ? this.batchTextConfig.remove.title : this.tableButtonTextConfig.remove.title
            let message = bool ? this.batchTextConfig.remove.message : this.tableButtonTextConfig.remove.message
            let removeTextConfig = this.tableButtonTextConfig.remove
            this.$confirm(message, title, {
                confirmButtonText: removeTextConfig.ok,
                cancelButtonText: removeTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                deleteInstanceEnvDetails({ids: ids}).then(res => {
                    this.$message({
                        type: 'success',
                        message: removeTextConfig.success
                    });
                    this.search(1)
                })
            })
        },
        updateHeight() {
            if (document.getElementsByClassName('el-form')[0]) {
                this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 190
                this.height = this.height < 460 ? 460 : this.height
            }
        },
        formatSeconds(seconds) {
            // 处理空值和无效值
            if (seconds == null || isNaN(seconds) || seconds < 0) {
                return '00:00:00';
            }

            seconds = Math.floor(Number(seconds));

            const hrs = Math.floor(seconds / 3600);
            const mins = Math.floor((seconds % 3600) / 60);
            const secs = seconds % 60;

            return [
                hrs.toString().padStart(2, '0'),
                mins.toString().padStart(2, '0'),
                secs.toString().padStart(2, '0')
            ].join(':');
        },
        formatTimes(times) {
            if (times) {
                return times + ' 次'
            }
            return '0 次'
        }
    },
    created() {
        this.$store.dispatch("getExamPlan").then(res => {
            this.examPlanOptions = res.data
        });
        this.search(1)
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            that.updateHeight()
        }, 200);
        window.onresize = () => {
            that.updateHeight()
        };
    },
}
</script>

<style scoped>
.info {
    color: #555;
    font-size: 15px;
    margin-bottom: 12px;
}

.info span {
    color: #C0C4CC;
    margin-left: 12px;
}

.info i {
    color: #555;
}

.spaceBetween {
    display: flex;
    justify-content: space-between;
}
</style>
